/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Bookings_Filter_By_TypeInputs */

const en_admin_dashboard_bookings_filter_by_type = /** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter bookings by type`)
};

const nl_admin_dashboard_bookings_filter_by_type = /** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter reserveringen op type`)
};

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const de_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const es_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const fr_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const it_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const pt_br2_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const pl_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const hu_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/** @type {(inputs: Admin_Dashboard_Bookings_Filter_By_TypeInputs) => LocalizedString} */
const ro_admin_dashboard_bookings_filter_by_type = en_admin_dashboard_bookings_filter_by_type;

/**
* | output |
* | --- |
* | "Filter bookings by type" |
*
* @param {Admin_Dashboard_Bookings_Filter_By_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_bookings_filter_by_type = /** @type {((inputs?: Admin_Dashboard_Bookings_Filter_By_TypeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Bookings_Filter_By_TypeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "de") return de_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "es") return es_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "fr") return fr_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "nl") return nl_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "it") return it_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "pl") return pl_admin_dashboard_bookings_filter_by_type(inputs)
	if (locale === "hu") return hu_admin_dashboard_bookings_filter_by_type(inputs)
	return ro_admin_dashboard_bookings_filter_by_type(inputs)
});
export { admin_dashboard_bookings_filter_by_type as "admin.dashboard.bookings_filter_by_type" }